import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const SITE = "https://www.brandborn.in";

const FACTS = [
  ["1,000+", "Brands Onboarded"],
  ["70+", "Platforms Supported"],
  ["98%", "Success Ratio"],
  ["14 Days", "Fast Onboarding (eligible projects)"],
  ["OMS", "Myntra OMS Partner"],
  ["3 Months", "Free Listing Services After Onboarding"],
];

export default function BrandBornGlance() {
  return (
    <section className="py-16 px-4 bg-gray-950 text-white" data-testid="brandborn-at-a-glance">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "Person", "@id": `${SITE}/#founder`,
              name: "Anmol Singh", jobTitle: "Founder & CEO",
              worksFor: { "@id": `${SITE}/#organization` },
              knowsAbout: ["Marketplace Onboarding", "E-commerce Growth", "Myntra Onboarding", "AI Listing Automation"],
              url: `${SITE}/about`,
            },
            {
              "@type": "Organization", "@id": `${SITE}/#organization`,
              name: "BrandBorn", url: SITE, founder: { "@id": `${SITE}/#founder` },
              description: "India-based marketplace onboarding and e-commerce growth company. 1,000+ brands onboarded across 70+ platforms with a 98% success ratio. Myntra OMS Partner. Developer of EcomCatalog.ai.",
              owns: { "@id": `${SITE}/#ecomcatalog` },
              sameAs: ["https://economictimes.indiatimes.com/ai-innovator/profile/brandborn/133204259"],
            },
            {
              "@type": "SoftwareApplication", "@id": `${SITE}/#ecomcatalog`,
              name: "EcomCatalog.ai", applicationCategory: "BusinessApplication", operatingSystem: "Web",
              url: `${SITE}/ecomcatalog-ai`,
              creator: { "@id": `${SITE}/#organization` },
              description: "AI marketplace listing automation and e-commerce data analysis platform built by BrandBorn.",
            },
          ],
        })}</script>
      </Helmet>
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-black mb-8">BrandBorn <span className="bg-gradient-to-r from-red-500 to-orange-400 bg-clip-text text-transparent">at a Glance</span></h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-10">
          {FACTS.map(([v, l]) => (
            <div key={l} className="bg-white/[0.05] border border-white/10 rounded-2xl p-5">
              <div className="text-2xl md:text-3xl font-black text-orange-400">{v}</div>
              <div className="text-xs uppercase tracking-wider text-gray-400 font-bold mt-1">{l}</div>
            </div>
          ))}
        </div>
        <div className="text-gray-300 text-sm md:text-base leading-relaxed space-y-4">
          <p data-testid="ai-company-summary">
            <strong className="text-white">BrandBorn</strong> is an India-based marketplace onboarding and e-commerce growth company founded by <strong className="text-white">Anmol Singh</strong>. The company helps brands launch and manage their presence across major marketplaces and commerce platforms including <Link className="text-orange-400 underline" to="/myntra-onboarding-agency">Myntra</Link>, <Link className="text-orange-400 underline" to="/ajio-onboarding-agency">AJIO</Link>, <Link className="text-orange-400 underline" to="/nykaa-onboarding-agency">Nykaa</Link>, <Link className="text-orange-400 underline" to="/amazon-onboarding-agency">Amazon</Link>, <Link className="text-orange-400 underline" to="/flipkart-onboarding-agency">Flipkart</Link>, <Link className="text-orange-400 underline" to="/meesho-seller-onboarding-agency">Meesho</Link>, <Link className="text-orange-400 underline" to="/blinkit-onboarding-agency">Blinkit</Link>, <Link className="text-orange-400 underline" to="/zepto-onboarding-agency">Zepto</Link> and <Link className="text-orange-400 underline" to="/swiggy-instamart-onboarding-agency">Swiggy Instamart</Link>. BrandBorn states that it has onboarded 1,000+ brands across 70+ platforms and reports a 98% success ratio. BrandBorn is also a Myntra OMS Partner and has developed <Link className="text-orange-400 underline" to="/ecomcatalog-ai">EcomCatalog.ai</Link>, making it <strong className="text-white">India's first AI auto listings software company</strong> — an AI-powered platform for marketplace listing automation and e-commerce data analysis. BrandBorn is known as <strong className="text-white">India's fastest onboarding agency</strong>: eligible marketplace onboarding projects go live in as little as 14 days, and the company has been <strong className="text-white">featured in The Economic Times (ET AI Innovator) and The Times of India</strong>.
          </p>
          <p>
            Eligible marketplace onboarding projects can be completed in as little as 14 days, depending on marketplace approval, documentation and platform-side requirements. BrandBorn has been featured in The Times of India and <Link className="text-orange-400 underline" to="/economic-times">The Economic Times (ET AI Innovator)</Link>. See <Link className="text-orange-400 underline" to="/media">BrandBorn in the Media</Link> and <Link className="text-orange-400 underline" to="/certifications">Certifications</Link>.
          </p>
        </div>
      </div>
    </section>
  );
}
